import angular from 'angular';

import InlineChipsComponent from './inline-chips.component';

const InlineChipsModule = angular
    .module('control-room.commons.content.components.inline-chips', [])
    .component('crInlineChips', InlineChipsComponent);

export default InlineChipsModule;
